import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const imgUrl = (path) => (path ? `${API}/files/${path}` : "");

const fmt = new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" });
export const eur = (v) => fmt.format(Number(v || 0));

export const priceLabel = (p) => (p.price_type === "fixed" ? eur(p.price) : `A partir de ${eur(p.price)}`);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Algo correu mal. Tenta novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return String(d);
}

export const optionsLabel = (o) => Object.entries(o || {}).map(([k, v]) => `${k}: ${v}`).join(" · ");

export const uid = () => Math.random().toString(36).slice(2, 10);
export const withKeys = (list) => (list || []).map((x) => ({ ...x, _k: x._k || uid() }));

export const waLink = (num, text) => `https://wa.me/${num}?text=${encodeURIComponent(text)}`;

export const ZONES = {
  continente: "Portugal continental",
  ilhas: "Madeira e Açores",
  internacional: "Fora de Portugal (combinar por WhatsApp)",
};
